import React from "react";
import { useSwipeable, SwipeableProps } from "react-swipeable";

function useSwipeableByRef(
  ref: React.RefObject<HTMLElement>,
  options: SwipeableProps
) {
  const handlers = useSwipeable(options);

  React.useEffect(() => {
    const node = ref?.current;
    if (node) {
      handlers.ref(node);
    }
  }, [handlers, ref]);
}

export default useSwipeableByRef;
